import { selectProtocolSearchSchema } from "@blockdaemon/widget-host";
import { createFileRoute } from "@tanstack/react-router";
import { zodValidator } from "@tanstack/zod-adapter";

import { DefiSelectProtocolPage } from "../../features/defi/pages/defi-select-protocol-page";

export const Route = createFileRoute("/_layout/defi/stablecoins/$tokenAddress")({
  component: DefiSelectProtocolPage,
  validateSearch: zodValidator(selectProtocolSearchSchema),
});
